import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

import LastEditorInfo from '../../../app/components/LastEditorInfo';
import ValidationAlert from '../../../app/components/ValidationAlert';
import FormRow from '../../../app/components/FormRow';
import { GetLastEditorDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { ExamBlockSchema } from '../../../common/spdCore/validation/schemas';
import { validateAgainst } from '../../../common/spdCore/validation/validateAgainst';

interface ExamBlockModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (reason: string) => void;
  initialReason?: string | null;
  title?: string;
  confirmLabel?: string;
  blockId?: string;
  getLastEditor?: (id: string) => Promise<GetLastEditorDto>;
}

export const ExamBlockModal: React.FC<ExamBlockModalProps> = ({
  show,
  onHide,
  onConfirm,
  initialReason,
  title = 'Zablokuj badanie',
  confirmLabel = 'Zablokuj',
  blockId,
  getLastEditor,
}) => {
  const [reason, setReason] = useState(initialReason ?? '');
  const [errors, setErrors] = useState<string[]>([]);

  useEffect(() => {
    if (show) {
      setReason(initialReason ?? '');
      setErrors([]);
    }
  }, [show, initialReason]);

  const handleConfirm = async () => {
    const result = await validateAgainst(ExamBlockSchema, { reason });
    if (!result.valid) {
      setErrors(result.errors);
      return;
    }
    setErrors([]);
    onConfirm(reason);
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="d-grid gap-3">
          <FormRow controlId="reason" label="Przyczyna blokady">
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder="Podaj przyczynę blokady..."
            />
          </FormRow>
        </Form>
        <ValidationAlert show={errors.length > 0} errors={errors} />
      </Modal.Body>
      <Modal.Footer>
        {blockId && getLastEditor && (
          <LastEditorInfo
            id={blockId}
            method={getLastEditor}
            className="me-auto"
          />
        )}
        <Button variant="secondary" onClick={onHide}>
          Anuluj
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
